import DotMenu from './menu'
import Option from './option'

DotMenu.Option = Option

export default DotMenu
